module.exports = __webpack_public_path__ + "static/headmade.9577d2aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/headmade.png
// module id = 523
// module chunks = 114276838955818